import { GamePlayer, gamePlayerNull } from './game-player'
import { GameStatus } from '../types/game.status'
import { Card } from './card'
import { Contract, contractNull } from './contract'

export interface GameProps {
  readonly gamePlayId: string
  readonly gameId: string
  readonly user: GamePlayer
  readonly rightOpponent: GamePlayer
  readonly leftOpponent: GamePlayer
  readonly shouldShowTalonCardsOnTable: boolean
  readonly shouldShowTalonCardsInGameInfo: boolean
  readonly isContractDeclared: boolean
  readonly shouldShowTalonCardsOnTableFaceUp: boolean
  readonly talonCards: Card[]
  readonly discardedCards: Card[]
  readonly contract: Contract
  readonly gameStatus: GameStatus
  readonly shouldShowDeclaredDefendOptions: boolean
  readonly doublingCountRoundsLeftToQueue: number
  readonly doublingCountRoundsQueued: number
  readonly isDoublingCountRound: boolean
  readonly shouldShowContractSection: boolean
  readonly shouldShowPreviousTrick: boolean
  readonly shouldShowBiddingSection: boolean
  readonly shouldShowUserActions: boolean
  readonly isUserCardsSelectable: boolean
  readonly isTalonCardsSelectable: boolean
  readonly shouldPoll: boolean
  readonly highlightedCards: Card[]
  readonly shouldShowPassFailStatus: boolean
}

export const gamePropsNull: GameProps = {
  gamePlayId: '',
  gameId: '',
  user: gamePlayerNull,
  rightOpponent: gamePlayerNull,
  leftOpponent: gamePlayerNull,
  shouldShowTalonCardsOnTable: false,
  shouldShowTalonCardsInGameInfo: false,
  isContractDeclared: false,
  shouldShowTalonCardsOnTableFaceUp: false,
  talonCards: [],
  discardedCards: [],
  contract: contractNull,
  gameStatus: 'Bidding',
  shouldShowDeclaredDefendOptions: false,
  doublingCountRoundsLeftToQueue: 0,
  doublingCountRoundsQueued: 0,
  isDoublingCountRound: false,
  shouldShowContractSection: false,
  shouldShowPreviousTrick: false,
  shouldShowBiddingSection: false,
  shouldShowUserActions: false,
  isUserCardsSelectable: false,
  isTalonCardsSelectable: false,
  shouldPoll: false,
  highlightedCards: [],
  shouldShowPassFailStatus: false,
}
